export const singleGameSuitesData = [
  {
    id: "20",
    buttonText: "Legends of Tampa Bay Suite",
    info:
      "Entertain more guests in style in one of our larger, remodeled suite locations that offers an unbeatable view.",
    bullets: [
      "22 suite tickets and 4 VIP parking passes",
      "Private restroom in suite",
      "Flat screen television",
    ],
    mapSrc: require("@/assets/images/SingleGameSuites/map-legends.png"),
    mapAlt: "Seating Map",
    imgSrc: require("@/assets/images/SingleGameSuites/Legends-of-Tampa-Bay-Suite.jpg"),
    imgAlt: "Tampa Suite",
  },
  {
    id: "21",
    buttonText: "Infield Suites",
    info:
      "The Infield Suites are right above the action on the field. Bring out your clients, employees, and guests to an experience they won't forget.",
    bullets: [
      "16 suite tickets and 3 VIP parking passes",
      "Flat screen television",
    ],
    mapSrc: require("@/assets/images/SingleGameSuites/map-infield.png"),
    mapAlt: "Seating Map",
    imgSrc: require("@/assets/images/SingleGameSuites/Infield-Suite.jpg"),
    imgAlt: "Infield Suite",
  },
  {
    id: "22",
    buttonText: "Baseline Suites",
    info:
      "Our exclusive Baseline Suites offer you a first class environment for business networking or rewarding top performing employees.",
    bullets: [
      "16 suite tickets and 3 VIP parking passes",
      "Flat screen television",
    ],
    mapSrc: require("@/assets/images/SingleGameSuites/map-baseline.png"),
    mapAlt: "Seating Map",
    imgSrc: require("@/assets/images/SingleGameSuites/Baseline-Suite.jpg"),
    imgAlt: "Baseline Suite",
  },
  {
    id: "23",
    buttonText: "Outfield Suites",
    info:
      "The Outfield Suites at Tropicana Field allow you to enjoy the game from the privacy of your own space.",
    bullets: [
      "12 suite tickets and 3 VIP parking passes",
      "Option of purchasing up to 4 additional suite tickets",
      "Flat screen television",
    ],
    mapSrc: require("@/assets/images/SingleGameSuites/map-outfield.png"),
    mapAlt: "Seating Map",
    imgSrc: require("@/assets/images/SingleGameSuites/Outfield-Suite.jpg"),
    imgAlt: "Outfield Suite",
  },
  {
    id: "24",
    buttonText: "Executive Suites",
    info:
      "Experience the impressive look and design of the Rays Executive Suites. These suites offer you a first-class atmosphere and the size to invite more of your clients, employees and friends.",
    bullets: [
      "28 suite tickets and 6 VIP parking passes",
      "Option of purchasing up to 8 additional suite tickets",
      "Flat screen television",
    ],
    mapSrc: require("@/assets/images/SingleGameSuites/map-executive.png"),
    mapAlt: "Seating Map",
    imgSrc: require("@/assets/images/SingleGameSuites/Executive-Suite.jpg"),
    imgAlt: "Executive Suite",
  },
  {
    id: "25",
    buttonText: "Hooters Owl's Den Suite",
    info:
      "Our unique Hooters Owl's Den is perfect for your next company outing or celebration.",
    bullets: [
      "36 suite tickets and 6 VIP parking passes",
      "Option of purchasing up to 12 additional suite tickets",
      "Flat screen television",
    ],
    mapSrc: require("@/assets/images/SingleGameSuites/map-hooters.png"),
    mapAlt: "Seating Map",
    imgSrc: require("@/assets/images/SingleGameSuites/Hooter-Owl-Den.jpg"),
    imgAlt: "Hooter's Den",
  },
  {
    id:"26",
    buttonText: "The Baldwin Group Club Suites",
    info: "",
    bullets: [
      "20 suite tickets and 3 VIP parking passes",
      "Ability to combine two or more suites to increase the size of your event",
      "All-inclusive buffet (featured entrees and ballpark fare), plus bar service (beer and wine)<br />* Spirits will be available for purchase",
      "Flat screen television",
    ],
    mapSrc: require("@/assets/images/SingleGameSuites/map-rays-club.png"),
    mapAlt: "Seating Map",
    imgSrc: require("@/assets/images/SingleGameSuites/AeroVanti-Club-Suite.jpg"),
    imgAlt: "Rays Club",
  },
];
